/**
 * Форматирует адрес кошелька в короткий вид
 * @example "0x1234567890abcdef" → "0x1234...cdef"
 */
export const formatWalletAddress = (address: string): string => {
  if (address.length <= 13) return address;
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
};

/**
 * Форматирует денежную сумму со знаком
 * @example 1234.56 → "+$1,234.56"
 * @example -1234.56 → "-$1,234.56"
 */
export const formatCurrency = (
  amount: number,
  options?: {
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
    showSign?: boolean;
  }
): string => {
  const { maximumFractionDigits = 2, showSign = true } = options || {};
  const minimumFractionDigits = Math.min(
    options?.minimumFractionDigits ?? maximumFractionDigits,
    maximumFractionDigits
  );

  const sign = showSign ? (amount >= 0 ? '+' : '') : '';
  const formatted = Math.abs(amount).toLocaleString('en-US', {
    minimumFractionDigits,
    maximumFractionDigits,
  });

  return `${sign}$${formatted}`;
};

/**
 * Форматирует процентное значение со знаком
 * @example 12.5 → "+12.5%"
 * @example -5.3 → "-5.3%"
 */
export const formatPercentage = (
  value: number,
  options?: {
    decimals?: number;
    showSign?: boolean;
    suffix?: string;
  }
): string => {
  const { decimals = 1, showSign = true, suffix = '%' } = options || {};

  const sign = showSign ? (value >= 0 ? '+' : '') : '';
  return `${sign}${value.toFixed(decimals)}${suffix}`;
};
